import type { ReactNode, JSX } from 'react'

import Modal from 'react-modal'

import CloseButton from '@components/buttons/close-button'

import styles from './layout-modal.module.scss'

Modal.setAppElement('body')

export type LayoutModalProps = {
  isOpen: boolean
  close: () => void
  children: ReactNode
  title: ReactNode
}

/**
 * @summary A full screen modal used for search and menu.
 * @see This component has to be loaded lazily
 */
export default function LayoutModal({ isOpen, close, children, title }: LayoutModalProps): JSX.Element {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      closeTimeoutMS={400}
      shouldFocusAfterRender
      className={{
        base: styles.modal,
        afterOpen: styles['modal--open'],
        beforeClose: styles['modal--close'],
      }}
      overlayClassName={{
        base: styles.overlay,
        afterOpen: styles['overlay--open'],
        beforeClose: styles['overlay--close'],
      }}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          {title}
          <CloseButton onClick={close} variant="square" className={styles.close} />
        </div>
        {children}
      </div>
    </Modal>
  )
}
